"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



// Loads an account's API keys, naming the account by orgKey. Results are
// kept per orgKey, so one account's list never shows on another's page.
 const useAccountAPIKeys = (orgKey) => {
  const [loaded, setLoaded] = _react.useState(null)
  const [failedOrgKey, setFailedOrgKey] = _react.useState(null)

  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      _actions2.default.listAPIKeys({ OrgKey: orgKey })
        .then(list => { if (isCurrent) setLoaded({ orgKey, list }) })
        .catch(() => { if (isCurrent) setFailedOrgKey(orgKey) })
      return () => { isCurrent = false }
    },
    [orgKey],
  )

  const onKeyChanged = _react.useCallback.call(void 0, 
    (changedIn, key) => setLoaded(l => l && l.orgKey === changedIn
      ? { ...l, list: { ...l.list, Keys: l.list.Keys.map(k => k.ID === key.ID ? key : k) } }
      : l),
    [],
  )

  // Reloads the list, as after a key is created; it only replaces the list
  // of that same account.
  const onKeyCreated = _react.useCallback.call(void 0, 
    (createdIn) => _actions2.default.listAPIKeys({ OrgKey: createdIn })
      .then(list => setLoaded(l => l && l.orgKey === createdIn ? { orgKey: createdIn, list } : l))
      .catch(() => undefined), // the list stays as it was; the new key shows on the next load
    [],
  )

  const list = _optionalChain([loaded, 'optionalAccess', _ => _.orgKey]) === orgKey ? loaded.list : null
  return {
    list,
    hasLoadFailed: !list && failedOrgKey === orgKey,
    onKeyChanged,
    onKeyCreated,
  }
}; exports.useAccountAPIKeys = useAccountAPIKeys
